import { CdCardTypes } from "src/cdScripts/Helpers/CdCardTypes";

export class PkCardTypes {

    static ArActTypeID = '29ea1af0-4cd0-4a34-9184-8dc275672e1a';
    static ArEDocumentTypeID = 'ba0c2336-267c-49b8-bb4c-78cd620cdd82';
    static PkAssignmentTypeID = '11929c1b-0aa0-48c8-99bc-2058378647cc';
    static PkDocVisionProtocolTypeID = '133732ae-12fe-4c61-8455-37e2139a5549';
    static PkIncomingTypeID = '0ca52091-fd54-4e72-bfba-b31ca18de901';
    static PkLetterCreditTypeID = '10a3e047-6943-45df-8779-8a832a205978';
    static PkMemoTypeID = 'debdbddb-030b-433b-b8df-8cf98a72344e';
    static PkOutgoingTypeID = '9485e570-954a-4d90-bbc7-6610fe9674e4';
    static RdndTypeID = '1b61abab-6643-40bd-852f-c7b0753b72aa';
    static RdndTypeName = 'ОРД';
    static PkProtocolTenderTypeID = 'd85b4a17-2e58-459e-bf80-958ad88a7c56';
    static PkWorkOrderTypeID = '502955b1-a3ad-4d90-99ea-0205ebc4d139';
    static PkInternalDocumentationTypeID = '65e9d23f-551c-4386-b49f-c0eb40c693fa';
    static PkPacketVirtualTypeID = 'ae8e3ad3-3e30-4d20-969a-2565bd92c957';
    static PkPacketVirtualTypeName = 'PkPacketVirtual';
    static InstructionTypeID = 'bb3719cc-5033-4c95-92ec-01411c170b97';
    static PkProtocolTypeID = '0abe23f3-0d5a-485b-ba15-64ec86c0296b';
    static PkCaseNewTypeID = 'd57a5f2f-67f2-4ff8-a01e-5f022367c2d7';
    static PkClientDocumentTypeID = 'fc6c8258-3ad8-407f-9802-234da18b3bc6';
    static PkClientPacketVirtualTypeID = '4af28e4d-c886-42d4-b14c-06bd20e2c1d9';
    static PkRecevingDocumentsFromDiadocPluginSettings = 'c193ad11-ca98-413c-96b2-b06520905c51';
    static ArUnitsOfDiadocTypeID = 'c7861924-95e3-4172-beeb-ac6374ab9219';
    static ArUserOfDiadocTypeID = 'c6ca5261-377c-4c15-a470-ff360ee026b7';
    static PkInnerDocumentTypeID = '9ed3948d-659e-4f96-9776-9bce3d9bcf50';
    static PkPersonnelDocumentTypeID = 'd7441ba6-ac0e-4ecd-9ef7-1b23137a9713';
    static PkPersonnelPacketVirtualTypeID = '33364e57-1b05-401c-a412-63be11c5dd3b';
    static PkTCOfferTypeID = '6dca5b3d-7e33-4b30-ad3d-3849a4265ae8';
    static PkDialogsTypeID = 'fb1f559e-c78b-44fa-8600-10cb888aff45';
    static PkDialogsTypeName = 'PkDialogs';
	static DepartmentRoleTypeID = 'abe57cb7-e1cb-06f6-b7ca-ad1668bebd72';
	static PkArticleStickerTypeID = '1550c54a-c582-4ac7-be0f-47cca2ca277d';
    static PkCovenantTypeID = '8d3e2166-5015-4cbe-8bbc-4936e6f3ab66';
    static PkPackageOfOriginalDocumentsTypeID = '14c99637-3224-4b3b-84da-ea9f69d2fa9d';
    static PkMdsSettingsCardTypeID = '00fdf993-8676-4c0f-ba38-3168cb896ec1';
    static PkEksSettingsCardTypeID = '44885e8d-f8c7-460c-80b1-a6222af3ed6c';
    static ArRolePerformersTypeID = 'b0dbda6f-6e2b-4e9d-b4be-32bd064f596a';
    static PkPartnerExceptionTypeID = '64521935-b6d4-4225-8bbd-71431ccb67f6';
    static PkMemoTemplateTypeID = 'b9c39283-378e-4dff-bbff-57a70d16b074';
    static PkExpertTypeID = '5719a895-ebbe-453b-9660-1382542a8b08';
    static ArContractTypeID = '51596f1c-1829-40f4-b471-22c45a3978fd';
    static ContractTypeID = '335f86a1-d009-012c-8b45-1f43c2382c2d';
    static ECMContractDocumentTypeID = '0c983eea-1320-4e8f-9f76-4626e12a8d18';
    static PkMatrixAccountantTypeID = '53100219-88ee-4192-8626-e3d52cb626be';
    static PkMatrixAccountantOHRTypeID = '5f1ec40c-a7eb-4c12-9099-b97e2efec4c6';
    static PkMatrixEditorHistoricalDocumentsTypeID = '60e95dfd-3526-49cd-8af2-a56680601053';
    static PkMatrixConsolidatingTypeID = '4369500a-9cab-4175-969f-201543ab8827';
    static PkMatrixLawyerTypeID = 'c0f1a5a0-e123-4da3-86ff-8ebb8df35c83';
    static PkMatrixRemarkTypeID = '017a024e-2ff5-473b-aff1-412d7b91dcbf';
    static PkCorrespondenceSendingRequestTypeID = '82a37048-a09a-4f00-93d3-09dab4393934';
    static PkEnvelopeTypeID = '20e40fa6-a610-46ae-a054-b7e2baa9ccb2';
    static PkSettingsContractorInPerimetrTypeID = 'aec187ef-1eca-4a9a-92c7-67b404cb2915';
    static PkForceMessageHandlingByJsonTypeID = 'ff3278a1-d4eb-4e85-872d-9f6a59dc1334';
    static PkContractCategoryTypeID = '750765ae-dac5-4209-9a9c-7a25498630bc';
    
    static PkOutgoingTypeName = 'PkOutgoing';
    static PkMatrixLandAssetCompaniesTypeID = '0f4a0a0b-4aae-4837-8896-8dd09752b3c7';
    static PkCreatorsContractsTechnicalCategoryTypeID = '5f3ebefd-0080-4d7d-8d4e-cd3f92711b40';
    static PkDocumentRecognitionServiceSettingsCardTypeID = '852b89e9-4d2a-4695-ac01-7a73b5e11f9d';

    static FdDialogsTypeID = '38f636d6-d863-4c28-9a20-ab1dd23c3cf7';
    static FdDialogsTypeName = 'FdDialogs';

    static ArHRPersonalDataTypeID = 'f7df7256-2583-415b-8da9-46864cd644f4';
    static ArKonturPoAApiSettingsTypeID = 'c3d5b832-ad80-4887-b247-d3a9eb26e073';
    static ArPoASettingsTypeID = 'f3ca3fc3-77ca-49cd-989c-acc6a81642df'

    static PersonalRoleID = '929ad23c-8a22-09aa-9000-398bf13979b2';

    static ChanceryCardTypes: string[] = [
      PkCardTypes.RdndTypeID,
      PkCardTypes.PkInternalDocumentationTypeID,
      PkCardTypes.PkAssignmentTypeID,
      PkCardTypes.PkMemoTypeID,
      PkCardTypes.PkOutgoingTypeID,
      PkCardTypes.PkIncomingTypeID
    ];

    static CopyTileCardTypes: string[] = [
      PkCardTypes.PkProtocolTenderTypeID,
      PkCardTypes.PkWorkOrderTypeID,
      PkCardTypes.PkInnerDocumentTypeID,
      PkCardTypes.PkCovenantTypeID,
      PkCardTypes.PkCorrespondenceSendingRequestTypeID
    ];

    static TypesOfDocumentsWithApprovalLists: string[] = [
      PkCardTypes.PkOutgoingTypeID,
      PkCardTypes.PkIncomingTypeID,
      PkCardTypes.PkAssignmentTypeID,
      PkCardTypes.PkMemoTypeID,
      PkCardTypes.RdndTypeID,
      PkCardTypes.InstructionTypeID,
      PkCardTypes.PkLetterCreditTypeID,
      PkCardTypes.ArActTypeID,
      PkCardTypes.PkProtocolTenderTypeID,
      PkCardTypes.PkWorkOrderTypeID,
      PkCardTypes.PkInternalDocumentationTypeID,
      PkCardTypes.PkProtocolTypeID,
      PkCardTypes.ArEDocumentTypeID,
      PkCardTypes.PkInnerDocumentTypeID,
      PkCardTypes.PkPersonnelDocumentTypeID,
      PkCardTypes.PkTCOfferTypeID,
      PkCardTypes.PkCovenantTypeID,
      PkCardTypes.PkCorrespondenceSendingRequestTypeID,
      PkCardTypes.PkEnvelopeTypeID
    ];

    static RefsTableSupportedCardTypes: string[] = [
      PkCardTypes.RdndTypeID,
      PkCardTypes.PkInternalDocumentationTypeID,
      PkCardTypes.PkAssignmentTypeID,
      PkCardTypes.PkMemoTypeID,
      PkCardTypes.PkOutgoingTypeID,
      PkCardTypes.PkIncomingTypeID,
      PkCardTypes.ArActTypeID,
      PkCardTypes.PkProtocolTenderTypeID,
      PkCardTypes.PkWorkOrderTypeID,
      PkCardTypes.PkProtocolTypeID,
      PkCardTypes.ArEDocumentTypeID,
      PkCardTypes.PkInnerDocumentTypeID,
      PkCardTypes.PkPersonnelDocumentTypeID,
      PkCardTypes.PkTCOfferTypeID,
      PkCardTypes.PkCovenantTypeID,
      PkCardTypes.PkCorrespondenceSendingRequestTypeID,
      PkCardTypes.PkEnvelopeTypeID
    ];

    static PkUISettingsEnabledCardTypes: string[] = [      
      PkCardTypes.PkIncomingTypeID,
      CdCardTypes.ArPowerOfAttorneyTypeID,
      PkCardTypes.PkOutgoingTypeID,     
      CdCardTypes.ArPowersOfAttorneyAuthorityTypeID       
    ];

    static PkContractCardTypes: string[] = [      
      PkCardTypes.ECMContractDocumentTypeID,
      PkCardTypes.ContractTypeID,
      CdCardTypes.ArContractTypeID 
    ];

}